export const GENERAL_INFO = 'generalInfo';
export const SHIPPING_INFO = 'shippingInfo';
export const SEASONAL_INFO = 'seasonalInfo';
export const HOST_INFO = 'hostInfo';
export const HOST_LABEL = 'presenter';

export const COMMON_GROUNDINGS = {
  GENERAL_INFO,
  SHIPPING_INFO,
  SEASONAL_INFO,
};

export const ONE_TO_MANY_GROUNDINGS = {
  HOST_INFO,
};

export const PAGE_SECTIONS = [
  {
    id: 'settings',
    title: 'genericLabels.settings',
    description: 'aiGroundingsModerationPage.settingsDescription',
    content: [
      {
        id: HOST_INFO,
        label: 'aiGroundingsModerationPage.hostInformationLabel',
        description: 'aiGroundingsModerationPage.hostInformationDescription',
        component: {
          type: 'Hosts',
        },
      },
      {
        id: GENERAL_INFO,
        label: 'aiGroundingsModerationPage.generalInformationLabel',
        description: 'aiGroundingsModerationPage.generalInformationDescription',
        component: {
          type: 'Textarea',
          props: {
            resize: 'none',
            rows: 7,
            placeholder: 'aiGroundingsModerationPage.generalInformationPlaceholder',
          },
        },
      },
      {
        id: SHIPPING_INFO,
        label: 'aiGroundingsModerationPage.shippingInformationLabel',
        description: 'aiGroundingsModerationPage.shippingInformationDescription',
        component: {
          type: 'Textarea',
          props: {
            resize: 'none',
            rows: 7,
            placeholder: 'aiGroundingsModerationPage.shippingInformationPlaceholder',
          },
        },
      },
      {
        id: SEASONAL_INFO,
        label: 'aiGroundingsModerationPage.seasonalInformationLabel',
        description: 'aiGroundingsModerationPage.seasonalInformationDescription',
        component: {
          type: 'Textarea',
          props: {
            resize: 'none',
            rows: 7,
            placeholder: 'aiGroundingsModerationPage.seasonalInformationPlaceholder',
          },
        },
      },
    ],
  },
  {
    id: 'general',
    title: 'genericLabels.general',
    content: [
      {
        id: 'featureOverview',
        label: 'genericLabels.featureOverview',
        description: 'aiGroundingsModerationPage.featureOverviewDescription',
      },
      {
        id: 'settingsSectionCustomization',
        label: 'aiGroundingsModerationPage.settingsAndCustomizationLabel',
        description: 'aiGroundingsModerationPage.settingsAndCustomizationDescription',
      },
      {
        id: 'showSpecificCustomization',
        label: 'aiGroundingsModerationPage.showCustomizationLabel',
        description: 'aiGroundingsModerationPage.showCustomizationDescription',
      },
      {
        id: 'permissions',
        label: 'genericLabels.permissions',
        description: 'aiGroundingsModerationPage.permissionsDescription',
      },
      {
        id: 'securityAndCompliance',
        label: 'genericLabels.securityAndCompliance',
        description: 'aiGroundingsModerationPage.securityAndComplianceDescription',
      },
    ],
  },
];
